import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Card, Row, Col, Popover } from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';

import './analytics.css';


var cc_data;
var cc_data1;


// const countriesInfo = Object.keys(countrycodeLatlong).map(code =>({code, lat:countrycodeLatlong[code][0], long:countrycodeLatlong[code][1], name: countries[code.toUpperCase()]}))

class FirstPurchaseCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const { opensearchFirstPurchaseList, loading, userTheme, opensearchFirstPurchaseTotalList } = this.props;

		cc_data = opensearchFirstPurchaseList || [];
		cc_data = cc_data.sort((a, b) => a.key - b.key);
		cc_data.forEach((c,d)=>{
			cc_data[d].key_as_string = moment(new Date(c.key_as_string)).format("MMM-DD")
		})

		cc_data1 = opensearchFirstPurchaseTotalList || [];

		


		let seriesarray = [];
		let totalcount = [];

		if (cc_data && cc_data[0] && cc_data[0].planid && cc_data[0].planid.buckets) {
			cc_data1.forEach((d) => {
				let plancount = [];
				totalcount = [];
				cc_data.forEach((c) => {
					let doccount = c.planid.buckets.filter(f => f.key === d.key);
					if(doccount[0] && doccount[0].doc_count > 0){
						plancount.push(doccount[0].doc_count);
					}
					totalcount.push(c.doc_count);
				})
				seriesarray.push({ name: d.key, type: 'bar',  data: plancount });				
			})
			seriesarray.push({ name: 'total', type: 'bar',  data: totalcount });

		}

		
		const options = {
			tooltip: {
				trigger: 'axis'
			},
			legend: {
				type: 'scroll',
				data: cc_data1.map(d => d.key),
			  top: '7%',
			  left: 'center'
				
			},
			grid: {
				
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			xAxis: {
				type: 'category',
				data: cc_data.map(d => d.key_as_string),
				axisTick: {
					show: false
				},
				axisLabel: {
					//interval: 7,
					formatter: function (timestamp) {
						return moment(new Date(timestamp)).format("MMM-DD");
					}
				},
				axisLine: {
					lineStyle: {
						type: 'solid'
					}
				}
			},
			yAxis: {
				type: 'value'
			},
			series: seriesarray
		};

		let csv_data = [];
		cc_data.forEach( (c,i)=> {
			seriesarray.forEach(d => {
				if(d){
					csv_data.push({date : c.key_as_string, plans : d.name , count : d.data[i]})
				}
			})
		})

		return (
			<Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`First Time/One Time Subscription  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='FirstPurchaseCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={csv_data} target="_blank" filename={"First Time/One Time Subscription.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<ReactECharts style={{ height: 360, width: '100%' }} theme={userTheme} option={options} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} />
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchFirstPurchaseList: state.analytics.opensearchFirstPurchaseList,
	opensearchFirstPurchaseTotalList : state.analytics.opensearchFirstPurchaseTotalList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FirstPurchaseCard));
